import { useState } from "react";
import { Palette } from "lucide-react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const BlipSwatch = ({ color, auto, testid, large = false }) => {
  if (!color) return null;
  return (
    <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-slate-400" data-testid={testid}>
      <span className={`${large ? "h-6 w-6" : "h-3.5 w-3.5"} inline-block rounded-full border border-slate-600`} style={{ background: color.hex }} />
      {auto ? `Automático (#${color.id})` : `Blip #${color.id}`}
    </span>
  );
};

const Swatch = ({ c, selected, onPick, onHover }) => (
  <button type="button" title={`Blip #${c.id} · ${c.hex}`} onClick={() => onPick(c.id)} onMouseEnter={() => onHover(c)}
    data-testid={`blip-option-${c.id}`}
    className={`h-7 w-7 border transition-transform duration-150 hover:z-10 hover:scale-125 ${selected ? "border-emerald-300 ring-2 ring-emerald-400" : "border-slate-700"}`}
    style={{ background: c.hex }} />
);

export const BlipPicker = ({ colors, value, onPick }) => {
  const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(null);
  const pick = (id) => {
    onPick(id);
    setOpen(false);
  };
  const current = String(value ?? "").trim();
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className="h-10 border-slate-700 bg-slate-900" data-testid="org-blip-picker-toggle">
          <Palette className="mr-1 h-4 w-4" />Escolher
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[330px] border-slate-800 bg-slate-950 p-3" data-testid="org-blip-picker">
        <div className="mb-2 font-mono text-[10px] uppercase tracking-widest text-slate-500">Cores de blip GTA (0–85)</div>
        <div className="grid grid-cols-10 gap-1" onMouseLeave={() => setHover(null)}>
          {colors.map((c) => <Swatch key={c.id} c={c} selected={current !== "" && Number(current) === c.id} onPick={pick} onHover={setHover} />)}
        </div>
        <div className="mt-3 flex items-center justify-between">
          <span className="font-mono text-[11px] text-slate-400" data-testid="blip-picker-hover">{hover ? `Blip #${hover.id} · ${hover.hex}` : "Passa o rato por uma cor"}</span>
          <Button type="button" size="sm" variant="ghost" onClick={() => pick("")} className="h-7 text-xs" data-testid="blip-option-auto">Automático</Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
